import React from "react";
import { LockIcon } from "lucide-react";
import { MercadoPagoLogo } from "./MercadoPagoLogo";
import { trackMetaEvent } from "../utils/metaPixel";
import { checkoutUrl } from "../data/landing";
type CtaButtonProps = {
  label: string;
  href?: string;
  note?: string;
};
export function CtaButton({
  label,
  href = checkoutUrl,
  note = "Pago seguro mediante Mercado Pago"
}: CtaButtonProps) {
  return <div className="flex w-full flex-col items-center gap-3" data-id="element-46" data-mp="qjs9le76x577">
      <a href={href} onClick={() => {
      if (href === checkoutUrl) {
        trackMetaEvent("InitiateCheckout", {
          value: 16990,
          currency: "ARS"
        });
      }
    }} className="block w-full rounded-full bg-sun px-6 py-4 text-center font-sans text-base font-black uppercase tracking-wide text-plum-dark shadow-[0_8px_20px_-8px_rgba(224,163,0,0.8)] transition-[transform,background-color] duration-150 ease-out hover:bg-sun-dark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-plum/30 sm:text-lg" data-id="element-47" data-mp="qi7jc0rws8f5">
        {label}
      </a>
      <p className="flex items-center gap-2 text-sm text-muted" data-id="element-48" data-mp="39yrg5j2ou2ln">
        <LockIcon className="h-4 w-4 text-emerald-600" aria-hidden="true" data-id="element-49" data-mp="39z9imxfy1d20" />
        {note}
        <span className="flex h-7 items-center rounded-md border border-line bg-paper px-2 shadow-sm" data-id="element-50" data-mp="3ex2mhjtrxuz4">
          <MercadoPagoLogo className="h-5" data-id="element-51" data-mp="3jyia9jnc6fl7" />
        </span>
      </p>
    </div>;
}